import { useTranslation } from 'react-i18next'
import { Chip } from '@mui/material'

import { isVisibleInCenter } from '../constants'
import { SiteUnscope } from '../types'

const VISIBLE_COLORS = { color: '#587F31', bgcolor: '#E6F0D7' }
const HIDDEN_COLORS = { color: '#DC2626', bgcolor: '#FEE2E2' }

type CenterVisibilityProps = {
  site: SiteUnscope
}

const CenterVisibility = ({ site }: CenterVisibilityProps) => {
  const { t } = useTranslation()
  const isVisible = isVisibleInCenter(site)
  const colors = isVisible ? VISIBLE_COLORS : HIDDEN_COLORS

  return (
    <Chip
      size="small"
      role="status"
      icon={<i className={`fa-solid fa-${isVisible ? 'eye' : 'eye-slash'}`} aria-hidden="true" />}
      label={t(`admin_sites.card.${isVisible ? 'visible_in_center' : 'hidden_in_center'}`)}
      sx={{
        height: '24px',
        borderRadius: '50px',
        px: 1,
        fontSize: 10,
        fontWeight: 500,
        ...colors,
        '& .MuiChip-icon': { color: 'inherit', fontSize: 10, ml: 0, mr: 0.75 },
        '& .MuiChip-label': { p: 0 }
      }}
    />
  )
}

export default CenterVisibility
